// @oasis-permission-inherits: /studio-edits (studio-edits:view)
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_dash/studio-edits/")({
  validateSearch: z.object({
    type: z.enum(["user", "org"]).optional().default("user"),
    id: z.string().optional(),
    page: z.number().optional(),
  }),
  beforeLoad: ({ search }) => {
    const id = search.id?.trim();
    throw redirect({
      to: "/ai-edits/all",
      search: {
        surface: "website",
        ...(id && search.type === "org" ? { orgIds: id } : {}),
        ...(id && search.type === "user" ? { userIds: id } : {}),
      },
      replace: true,
    });
  },
});
